import React, { Fragment, useState } from 'react';
import ReactQuill from 'react-quill';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Slider } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Switch from '@mui/material/Switch';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import TextField from '@mui/material/TextField';

import ComplexQuestion from '../Questions/ComplexQuestion/ComplexQuestion';
import FileUploadQuestion from '../Questions/FileUploadQuestion/FileUploadQuestion';
import { LayoutQuestion } from '../Questions/LayoutQuestion';
import MatrixQuestion from '../Questions/MatrixQuestion/MatrixQuestion';
import MediaQuestion from '../Questions/MediaQuestion/MediaQuestion';
import { RelationalQuestions } from '../Questions/RelationQuestion/RelationalQuestion';
import SelectionQuestion from '../Questions/SelectionQuestion.jsx/SelectionQuestion';
import TableQuestion from '../Questions/TableQuestion/TableQuestion';

import { IsRequiredQuestion } from './IsRequiredQuestion';

import styles from './Form.module.css';
export default function Form(props) {
  const [categoryId, setCategoryId] = useState('');
  const [open, setOpen] = useState(false);
  const [fixedValue, setFixedValue] = useState('');

  const handleLimitChange = (event) => {
    props.setLimitType(event.target.value.toString());
  };

  // Funciones para abrir y cerrar el modal

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleAgregar = () => {
    // Lógica para agregar la pregunta
    handleCloseModal();
  };
  /**
   * Handle category id change.
   *
   * @param {object} event
   */
  const handleCategoryIdChange = ({ target }) => {
    props.handleCategoryIdChange(target.value);
    setCategoryId(target.value);
  };

  const renderForm = (type) => {
    switch (type.id) {
      case 1:
        return (
          <LayoutQuestion {...props}>
            {/* Switch para habilitar respuesta por voz */}
            <div style={{ marginTop: '1rem' }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={props.information.voiceEnabled || false}
                    onChange={(e) =>
                      props.handleInformation({
                        target: {
                          name: 'voiceEnabled',
                          value: e.target.checked,
                        },
                      })
                    }
                    name="voiceEnabled"
                  />
                }
                label="¿Desea grabar voz?"
              />
            </div>

            {/* Si está habilitada la voz, mostrar campo de duración */}
            {props.information.voiceEnabled && (
              <div className={styles.input} style={{ marginTop: '0.5rem' }}>
                <TextField
                  id="voice-duration"
                  label="Duración máxima (segundos)"
                  type="number"
                  value={props.information.voiceDuration || 120}
                  name="voiceDuration"
                  onChange={(e) => {
                    const value = parseInt(e.target.value, 10);
                    let finalValue = value;

                    if (value > 120) {
                      finalValue = 120;
                    } else if (value < 1 || isNaN(value)) {
                      finalValue = 1;
                    }

                    props.handleInformation({
                      target: {
                        name: 'voiceDuration',
                        value: finalValue,
                      },
                    });
                  }}
                  inputProps={{
                    min: 1,
                    max: 120,
                  }}
                  fullWidth
                  size="small"
                  helperText="Duración máxima: 60 segundos"
                />
              </div>
            )}

            {/* Si NO está habilitada la voz, mostrar opciones de validación */}
            {!props.information.voiceEnabled && (
              <div className={styles.input} style={{ marginTop: '0.5rem' }}>
                <TextField
                  select
                  label="Tipo de validación"
                  value={props.information.validationType || 'text'}
                  name="validationType"
                  onChange={props.handleInformation}
                  fullWidth
                  size="small"
                  helperText="Selecciona el tipo de entrada permitida"
                >
                  <MenuItem value="text">Alfanumérico (texto libre)</MenuItem>
                  <MenuItem value="number">Solo números</MenuItem>
                  <MenuItem value="email">Solo correo electrónico</MenuItem>
                </TextField>
              </div>
            )}

            {/* Select para límite de caracteres - SIEMPRE VISIBLE */}
            <div className={styles.input} style={{ marginTop: '0.5rem' }}>
              <TextField
                select
                label="Límite de caracteres"
                value={props.information.haveLimit ? 'limited' : 'unlimited'}
                name="haveLimit"
                onChange={(e) => {
                  const isLimited = e.target.value === 'limited';
                  props.handleInformation({
                    target: {
                      name: 'haveLimit',
                      value: isLimited,
                    },
                  });
                  // Si cambia a ilimitado, limpiamos el valor del límite
                  if (!isLimited) {
                    props.handleInformation({
                      target: {
                        name: 'wordRestricted',
                        value: '',
                      },
                    });
                  }
                }}
                fullWidth
                size="small"
                helperText="¿Deseas limitar la cantidad de caracteres?"
              >
                <MenuItem value="unlimited">Ilimitado</MenuItem>
                <MenuItem value="limited">Con límite de caracteres</MenuItem>
              </TextField>
            </div>

            {/* Input para límite de caracteres (solo si eligió "limited") */}
            {props.information.haveLimit && (
              <div className={styles.input} style={{ marginTop: '0.5rem' }}>
                <TextField
                  id="character-limit"
                  label="Límite de caracteres"
                  type="number"
                  value={props.information.wordSizeLimit || ''}
                  name="wordSizeLimit"
                  onChange={(e) => {
                    const value = parseInt(e.target.value, 10);
                    let finalValue = value;

                    if (isNaN(value) || value < 8) {
                      finalValue = 8;
                    } else if (value > 5000) {
                      finalValue = 5000;
                    }

                    props.handleInformation({
                      target: {
                        name: 'wordSizeLimit',
                        value: finalValue,
                      },
                    });
                  }}
                  inputProps={{
                    min: 8,
                    max: 5000,
                  }}
                  error={props.errorMessage.wordSizeLimit}
                  helperText={
                    props.helperText.wordSizeLimit ||
                    'Mínimo: 8, Máximo: 5000 caracteres'
                  }
                  fullWidth
                  size="small"
                  placeholder="Ej: 500"
                />
              </div>
            )}
          </LayoutQuestion>
        );

      case 21:
      case 23:
        return (
          <LayoutQuestion {...props}/>
        );
      case 2:
      case 16:
        return (
          <LayoutQuestion {...props}>
            <div className={styles.options}>
              {props.information.options.map((val, key) => {
                return (
                  <div className={styles.option} key={key}>
                    <div
                      style={{
                        padding: '3px 9px',
                        backgroundColor: '#fce4e4',
                        borderRadius: '4px',
                        textAlign: 'center',
                        marginRight: '15px',
                        fontSize: '12px',
                        color: '#808080',
                      }}
                    >
                      {key + 1}
                    </div>
                    <TextField
                      id={`option-${key}`}
                      variant="standard"
                      placeholder="Añadir opción..."
                      value={props.information.options[key]}
                      onChange={(event) =>
                        props.handleChangeOptions(event, key)
                      }
                      InputProps={{
                        disableUnderline: true,
                      }}
                      fullWidth
                      size="small"
                      disabled
                    />
                  </div>
                );
              })}
            </div>
          </LayoutQuestion>
        );
      case 3:
        return (
          <LayoutQuestion {...props}>
            <div className={styles.options}>
              {props.information.customOptions
                .map((opt, index) => ({ ...opt, index }))
                .filter((opt) => !opt.isOther)
                .map(({ value, index }, displayIndex) => (
                  <div className={styles.option} key={index}>
                    <div
                      style={{
                        padding: '3px 9px',
                        backgroundColor: '#F0F2F5',
                        borderRadius: '4px',
                        textAlign: 'center',
                        marginRight: '15px',
                        fontSize: '14px',
                        color: 'rgb(134, 140, 204)',
                      }}
                    >
                      {displayIndex + 1}
                    </div>
                    <TextField
                      id={`option-${index}`}
                      variant="standard"
                      placeholder="Añadir opción..."
                      value={value}
                      onChange={props.handleinformationoptions(index)}
                      error={props.customOptionError[index]}
                      helperText={
                        props.customOptionError[index]
                          ? 'La opción no puede estar vacía'
                          : ''
                      }
                      InputProps={{ disableUnderline: true }}
                      fullWidth
                      size="small"
                    />
                  </div>
                ))}
              {props.information.customOptions.length < 20 ? (
                <Button
                  variant="text"
                  startIcon={<AddCircleOutlineIcon />}
                  onClick={props.handleaddoption}
                  style={{ backgroundColor: '#F7F7F7', width: '255px' }}
                >
                  Añadir opción
                </Button>
              ) : null}
              {props.information.customOptions.length >= 3 ? (
                <Button
                  variant="text"
                  startIcon={<RemoveCircleOutlineIcon />}
                  onClick={() => {
                    const options = [...props.information.customOptions];
                    // Verificar si la última opción NO es "Otro"
                    const lastIndex = options.length - 1;
                    if (!options[lastIndex]?.isOther) {
                      props.handleRemoveOption(lastIndex);
                    }
                  }}
                  style={{ backgroundColor: '#F7F7F7', width: '255px' }}
                >
                  Eliminar opción
                </Button>
              ) : null}
              {/* Botón: Añadir opción "Otro" */}
              {!props.information.customOptions.some((opt) => opt.isOther) && (
                <Button
                  variant="text"
                  onClick={() => props.handleaddoption(15, '', true)}
                  style={{
                    backgroundColor: '#F7F7F7',
                    width: '255px',
                    marginTop: '0.5rem',
                  }}
                >
                  Añadir opción "Otro"
                </Button>
              )}

              {/* Campo para opción "Otro" siempre al final */}
              {props.information.customOptions.some((opt) => opt.isOther) && (
                <div className={styles.option}>
                  <div
                    style={{
                      padding: '3px 9px',
                      backgroundColor: '#F0F2F5',
                      borderRadius: '4px',
                      textAlign: 'center',
                      marginRight: '15px',
                      fontSize: '14px',
                      color: 'rgb(134, 140, 204)',
                    }}
                  >
                    {props.information.customOptions.filter(
                      (opt) => !opt.isOther,
                    ).length + 1}
                  </div>
                  <TextField
                    id="multiple-option-other"
                    variant="standard"
                    placeholder="Otro (especifique)"
                    value={
                      props.information.customOptions.find((opt) => opt.isOther)
                        ?.value || ''
                    }
                    onChange={(e) => {
                      const otherIndex =
                        props.information.customOptions.findIndex(
                          (opt) => opt.isOther,
                        );
                      props.handleinformationoptions(otherIndex)(e);
                    }}
                    InputProps={{ disableUnderline: true }}
                    fullWidth
                    size="small"
                  />
                </div>
              )}

              {/* Botón: Eliminar opción "Otro" */}
              {props.information.customOptions.some((opt) => opt.isOther) && (
                <Button
                  variant="text"
                  color="error"
                  onClick={() => {
                    const updatedOptions =
                      props.information.customOptions.filter(
                        (opt) => !opt.isOther,
                      );
                    const updatedInputs =
                      props.information.opcionesInputs?.slice(
                        0,
                        updatedOptions.length,
                      ) ?? [];
                    props.setInformation({
                      ...props.information,
                      customOptions: updatedOptions,
                      opcionesInputs: updatedInputs,
                    });
                  }}
                  style={{
                    backgroundColor: '#FDECEA',
                    width: '255px',
                    marginTop: '0.5rem',
                  }}
                >
                  Eliminar opción "Otro"
                </Button>
              )}
            </div>

            <div className={styles.input}>
              <FormControl fullWidth size="small" style={{ marginTop: '1rem' }}>
                <InputLabel id="limit-type-label">Tipo de límite</InputLabel>
                <Select
                  labelId="limit-type-label"
                  value={props.limitType}
                  label="Tipo de límite"
                  onChange={handleLimitChange}
                >
                  <MenuItem value="ilimitado">Ilimitado</MenuItem>
                  <MenuItem value="fijo">Valor fijo</MenuItem>
                </Select>
              </FormControl>

              {props.limitType === 'fijo' && (
                <TextField
                  label="Valor fijo"
                  placeholder="Por favor ingresa el valor máximo que los usuarios pueden seleccionar:"
                  value={props.score}
                  onChange={props.handleInformation}
                  style={{ marginTop: '0.8rem' }}
                  fullWidth
                  size="small"
                  name="maximunValueOptions"
                  error={props.errorMessage.maximunValueOptions}
                  helperText={props.helperText.maximunValueOptions}
                />
              )}
            </div>
          </LayoutQuestion>
        );
      case 8:
        return (
          <LayoutQuestion {...props}>
            <div className={styles.options}>
              {/* Opciones normales */}
              {props.information.customOptions
                .map((opt, originalIndex) => ({ ...opt, originalIndex }))
                .filter((opt) => !opt.isOther)
                .map(({ value, originalIndex }, displayIndex) => (
                  <div
                    className={styles.option}
                    key={`option-${originalIndex}`}
                  >
                    <div
                      style={{
                        padding: '3px 9px',
                        backgroundColor: '#F0F2F5',
                        borderRadius: '4px',
                        textAlign: 'center',
                        marginRight: '15px',
                        fontSize: '14px',
                        color: 'rgb(134, 140, 204)',
                      }}
                    >
                      {displayIndex + 1}
                    </div>
                    <TextField
                      id={`unique-option-${originalIndex}`}
                      variant="standard"
                      placeholder="Añadir opción..."
                      value={value}
                      onChange={props.handleinformationoptions(originalIndex)}
                      error={props.customOptionError[originalIndex]}
                      helperText={
                        props.customOptionError[originalIndex]
                          ? 'La opción no puede estar vacía'
                          : ''
                      }
                      InputProps={{ disableUnderline: true }}
                      fullWidth
                      size="small"
                    />
                  </div>
                ))}

              {/* Botón: Añadir opción */}
              {props.information.customOptions.length < 20 && (
                <Button
                  variant="text"
                  startIcon={<AddCircleOutlineIcon />}
                  onClick={() => props.handleaddoption(15)}
                  style={{
                    backgroundColor: '#F7F7F7',
                    width: '255px',
                  }}
                >
                  Añadir opción
                </Button>
              )}

              {/* Botón: Eliminar última opción (sin afectar "Otro") */}
              {props.information.customOptions.filter((opt) => !opt.isOther)
                .length >= 2 && (
                <Button
                  variant="text"
                  startIcon={<RemoveCircleOutlineIcon />}
                  onClick={() => {
                    // Encontrar el último índice de una opción normal (no "Otro")
                    const normalOptions = props.information.customOptions
                      .map((opt, index) => ({ ...opt, index }))
                      .filter((opt) => !opt.isOther);

                    if (normalOptions.length > 0) {
                      const lastNormalOptionIndex =
                        normalOptions[normalOptions.length - 1].index;
                      props.handleRemoveOption(lastNormalOptionIndex);
                    }
                  }}
                  style={{
                    backgroundColor: '#F7F7F7',
                    width: '255px',
                  }}
                >
                  Eliminar opción
                </Button>
              )}

              {/* Botón: Añadir opción "Otro" */}
              {!props.information.customOptions.some((opt) => opt.isOther) && (
                <Button
                  variant="text"
                  onClick={() => props.handleaddoption(15, '', true)}
                  style={{
                    backgroundColor: '#F7F7F7',
                    width: '255px',
                    marginTop: '0.5rem',
                  }}
                >
                  Añadir opción "Otro"
                </Button>
              )}

              {/* Campo para opción "Otro" siempre al final */}
              {props.information.customOptions.some((opt) => opt.isOther) && (
                <div className={styles.option}>
                  <div
                    style={{
                      padding: '3px 9px',
                      backgroundColor: '#F0F2F5',
                      borderRadius: '4px',
                      textAlign: 'center',
                      marginRight: '15px',
                      fontSize: '14px',
                      color: 'rgb(134, 140, 204)',
                    }}
                  >
                    {/* Calcular el número correcto para "Otro" */}
                    {props.information.customOptions.filter(
                      (opt) => !opt.isOther,
                    ).length + 1}
                  </div>
                  <TextField
                    id="unique-option-other"
                    variant="standard"
                    placeholder="Otro (especifique)"
                    value={
                      props.information.customOptions.find((opt) => opt.isOther)
                        ?.value || ''
                    }
                    onChange={(e) => {
                      const otherIndex =
                        props.information.customOptions.findIndex(
                          (opt) => opt.isOther,
                        );
                      props.handleinformationoptions(otherIndex)(e);
                    }}
                    InputProps={{ disableUnderline: true }}
                    fullWidth
                    size="small"
                  />
                </div>
              )}

              {/* Botón: Eliminar opción "Otro" */}
              {props.information.customOptions.some((opt) => opt.isOther) && (
                <Button
                  variant="text"
                  color="error"
                  onClick={() => {
                    const updatedOptions =
                      props.information.customOptions.filter(
                        (opt) => !opt.isOther,
                      );
                    const updatedInputs =
                      props.information.opcionesInputs?.slice(
                        0,
                        updatedOptions.length,
                      ) ?? [];
                    props.setInformation({
                      ...props.information,
                      customOptions: updatedOptions,
                      opcionesInputs: updatedInputs,
                    });
                  }}
                  style={{
                    backgroundColor: '#FDECEA',
                    width: '255px',
                    marginTop: '0.5rem',
                  }}
                >
                  Eliminar opción "Otro"
                </Button>
              )}
            </div>
          </LayoutQuestion>
        );

      case 5:
        return (
          <LayoutQuestion {...props}>
            <div className={styles.stars}>
              <Button
                variant="text"
                onClick={props.handledeletestars}
                style={{
                  backgroundColor: '#F7F7F7',
                  color: 'black',
                  fontSize: '1.8rem',
                  padding: '0',
                }}
              >
                -
              </Button>
              <div
                style={{
                  border: '1px solid #ddd',
                  padding: '18px 20px',
                  borderRadius: '4px',
                }}
              >
                {props.information.stars.length}
              </div>
              <Button
                variant="text"
                onClick={props.handleaddstars}
                style={{
                  backgroundColor: '#F7F7F7',
                  color: 'black',
                  fontSize: '1.8rem',
                  padding: '0',
                }}
              >
                +
              </Button>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: '0.3em',
                }}
              >
                {props.information.stars.map((val, index) => {
                  return (
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      key={index}
                    >
                      <path
                        d="M12.978 15.544L8.00001 11.8854L3.02201 15.544L4.93334 9.63536L-0.0419922 6.00003H6.10067L8.00001 0.0813599L9.89934 6.00003H16.0413L11.0667 9.63536L12.978 15.544Z"
                        fill="#ddd"
                      ></path>
                    </svg>
                  );
                })}
              </div>
            </div>
            <sub>{props.starmsg}</sub>
          </LayoutQuestion>
        );
      case 10:
        return <LayoutQuestion {...props}></LayoutQuestion>;
      case 13:
        return (
          <div>
            {!props.isConditionalQuestion && (
              <div className={styles.top}>
                <div className={styles.question}>
                  <div className={styles.number}>{`Q${props.questions}`}</div>
                  <div className={styles.input}>
                    <TextField
                      id="outlined-name"
                      variant="standard"
                      label="Añadir pregunta"
                      placeholder="Añadir pregunta aquí..."
                      value={props.information.name}
                      name="name"
                      onChange={props.handleInformation}
                      error={props.errorMessage.name}
                      helperText={props.helperText.name}
                      fullWidth
                      size="small"
                      InputProps={{
                        inputComponent: TextareaAutosize,
                      }}
                    />
                  </div>
                </div>
                <div className={styles.input}>
                  <TextField
                    id="outlined-description"
                    label="Añadir descripción"
                    placeholder="Añadir descripción aquí (opcional)..."
                    InputProps={{
                      inputComponent: TextareaAutosize,
                      inputProps: {
                        style: {
                          height: '80px',
                        },
                      },
                    }}
                    value={props.information.description}
                    style={{
                      width: '100%',
                      marginTop: '0.5rem',
                    }}
                    name="description"
                    onChange={props.handleInformation}
                  />
                </div>
                <div className={styles.options}>
                  {[...Array(2)].map((_, key) => (
                    <div
                      key={key}
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <div className={styles.option}>
                        <div
                          style={{
                            padding: '3px 9px',
                            backgroundColor: '#F0F2F5',
                            borderRadius: '4px',
                            textAlign: 'center',
                            marginRight: '15px',
                            fontSize: '14px',
                            color: 'rgb(134, 140, 204)',
                          }}
                        >
                          {key + 1}
                        </div>
                        <TextField
                          id={`outlined-option-${key}`}
                          variant="standard"
                          placeholder="Añadir opción..."
                          value={props.information.customOptions[key]}
                          onChange={props.handleinformationoptions(key)}
                          error={props.customOptionError[key]}
                          helperText={
                            props.customOptionError[key]
                              ? 'La opción no puede estar vacía'
                              : ''
                          }
                          InputProps={{
                            disableUnderline: true,
                          }}
                          fullWidth
                          size="small"
                        />
                      </div>
                      <div style={{ marginTop: '5px' }}>
                        <Button
                          variant="text"
                          startIcon={<AddCircleOutlineIcon />}
                          onClick={handleClickOpen}
                          style={{ backgroundColor: '#F7F7F7', width: '255px' }}
                        >
                          Añadir pregunta
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      case 14:
        return <LayoutQuestion {...props}></LayoutQuestion>;
      case 15:
        return <RelationalQuestions {...props} />;
      case 19:
        return (
          <LayoutQuestion {...props}>
            {/* Input numérico para el valor */}
            <div
              style={{
                marginTop: '4px',
              }}
            >
              <TextField
                label="Valor de respuesta"
                type="number"
                inputProps={{ min: 0, max: 10 }}
                value={props.information.barBipolarValue}
                name="barBipolarValue"
                onChange={props.handleInformation}
                variant="standard"
                fullWidth
                error={props.errorMessage.bipolar}
                helperText={
                  props.errorMessage.bipolar ? props.helperText.bipolar : ''
                }
              />
            </div>
            {/* Textos para los extremos de la escala */}
            <div
              style={{
                marginTop: '4px',
              }}
            >
              <TextField
                label="Texto extremo izquierdo"
                placeholder="Ej: Totalmente en desacuerdo"
                value={props.information.textsBipolarBar.leftText}
                name="textsBipolarBar.leftText"
                onChange={props.handleInformation}
                size="small"
                variant="standard"
                fullWidth
                error={props.errorMessage.bipolarText}
                inputProps={{
                  maxLength: 300, // ✅ Limita la entrada a 300 caracteres
                }}
                helperText={
                  props.errorMessage.bipolarText
                    ? props.helperText.bipolarText
                    : `${props.information.textsBipolarBar.leftText.length}/300` // ✅ Muestra el contador
                }
              />
            </div>
            <div
              style={{
                marginTop: '4px',
              }}
            >
              <TextField
                label="Texto extremo derecho"
                placeholder="Ej: Totalmente de acuerdo"
                value={props.information.textsBipolarBar.rigthText}
                name="textsBipolarBar.rightText"
                onChange={props.handleInformation}
                size="small"
                variant="standard"
                fullWidth
                error={props.errorMessage.bipolarText}
                inputProps={{
                  maxLength: 300, // ✅ Limita la entrada a 120 caracteres
                }}
                helperText={
                  props.errorMessage.bipolarText
                    ? props.helperText.bipolarText
                    : `${props.information.textsBipolarBar.rightText.length}/300` // ✅ Muestra el contador
                }
              />
            </div>
          </LayoutQuestion>
        );
      case 22:
        return (
          <LayoutQuestion {...props}>
            {/* Textos para los extremos de la escala */}
            <div
              style={{
                marginTop: '4px',
              }}
            >
              <TextField
                label="Texto extremo izquierdo"
                placeholder="Ej: Totalmente en desacuerdo"
                value={props.information.textsBipolarBar.leftText}
                name="textsBipolarBar.leftText"
                onChange={props.handleInformation}
                size="small"
                variant="standard"
                style={{ width: '45%' }}
                error={props.errorMessage.bipolarText}
                inputProps={{
                  maxLength: 25, // ✅ Limita la entrada a 120 caracteres
                }}
                helperText={
                  props.errorMessage.bipolarText
                    ? props.helperText.bipolarText
                    : `${props.information.textsBipolarBar.leftText.length}/25` // ✅ Muestra el contador
                }
              />
            </div>
            <div
              style={{
                marginTop: '4px',
              }}
            >
              <TextField
                label="Texto extremo derecho"
                placeholder="Ej: Totalmente de acuerdo"
                value={props.information.textsBipolarBar.rigthText}
                name="textsBipolarBar.rightText"
                onChange={props.handleInformation}
                size="small"
                variant="standard"
                style={{ width: '45%' }}
                error={props.errorMessage.bipolarText}
                inputProps={{
                  maxLength: 25, // ✅ Limita la entrada a 120 caracteres
                }}
                helperText={
                  props.errorMessage.bipolarText
                    ? props.helperText.bipolarText
                    : `${props.information.textsBipolarBar.rightText.length}/25` // ✅ Muestra el contador
                }
              />
            </div>
            <div className={styles.input} style={{ marginTop: '1rem' }}>
              <FormControl
                fullWidth
                size="small"
                style={{ marginBottom: '1rem' }}
              >
                <InputLabel id="first-select-label">
                  Seleccionar 0 o 1
                </InputLabel>
                <Select
                  labelId="first-select-label"
                  value={
                    [0, 1].includes(
                      Number(props.information.textsBipolarBar.valueLeft),
                    )
                      ? props.information.textsBipolarBar.valueLeft
                      : '0'
                  }
                  label="Seleccionar 0 o 1"
                  onChange={props.handleInformation}
                  name="textsBipolarBar.valueLeft"
                >
                  <MenuItem value={'0'}>0</MenuItem>
                  <MenuItem value={'1'}>1</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth size="small">
                <InputLabel id="second-select-label">
                  Seleccionar un número
                </InputLabel>
                <Select
                  labelId="second-select-label"
                  value={
                    props.information.secondSelectOptions.includes(
                      props.information.textsBipolarBar.valueRight,
                    )
                      ? props.information.textsBipolarBar.valueRight
                      : props.information.secondSelectOptions.length > 0
                        ? props.information.secondSelectOptions[0].toString()
                        : ''
                  }
                  label="Seleccionar un número"
                  onChange={props.handleInformation}
                  name="textsBipolarBar.valueRight"
                >
                  {props.information.secondSelectOptions.map((num) => (
                    <MenuItem key={num} value={num}>
                      {num}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </LayoutQuestion>
        );
      case 24:
        return (
          <LayoutQuestion {...props}>
            <FormControl component="fieldset" sx={{ mt: 2, mb: 4 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={props.information.autoValidate}
                    onChange={props.handleInformation}
                    name="autoValidate"
                  />
                }
                label="¿Deseas que el valor de la escala se valide automáticamente?"
              />
              <FormHelperText>
                Si se activa, el sistema validará automaticamente que el valor
                esté dentro del rango esperado.
              </FormHelperText>
            </FormControl>

            <div
              style={{
                marginTop: '4px',
              }}
            >
              <TextField
                label="Valor de la escala"
                type="number"
                inputProps={{ min: 0 }}
                value={props.information.barBipolarValue}
                name="barBipolarValue"
                onChange={props.handleInformation}
                variant="standard"
                fullWidth
                error={props.errorMessage.bipolar}
                helperText={
                  props.errorMessage.bipolar ? props.helperText.bipolar : ''
                }
              />
            </div>
            {/* Textos para los extremos de la escala */}

            <div>
              {props.information.customOptions.map((val, key) => {
                return (
                  <div
                    className={styles.option}
                    key={key}
                    style={{
                      marginTop: '10px',
                      marginBottom:
                        key === props.information.customOptions.length - 1
                          ? '10px'
                          : '',
                    }}
                  >
                    <div
                      style={{
                        padding: '3px 9px',
                        backgroundColor: '#F0F2F5',
                        borderRadius: '4px',
                        textAlign: 'center',
                        marginRight: '15px',
                        fontSize: '14px',
                        color: 'rgb(134, 140, 204)',
                      }}
                    >
                      {key + 1}
                    </div>
                    <TextField
                      id="outlined-name"
                      variant="standard"
                      placeholder="Añadir opción..."
                      value={props.information.customOptions[key].text}
                      onChange={props.handleinformationoptions(key)}
                      error={props.customOptionError[key]}
                      helperText={
                        props.customOptionError[key]
                          ? 'La opción no puede estar vacía'
                          : ''
                      }
                      InputProps={{
                        disableUnderline: true,
                      }}
                      fullWidth
                      size="small"
                    />
                  </div>
                );
              })}
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-around',
              }}
            >
              {props.information.customOptions.length < 20 ? (
                <Button
                  variant="text"
                  startIcon={<AddCircleOutlineIcon />}
                  onClick={props.handleaddoption}
                  style={{ backgroundColor: '#F7F7F7', width: '255px' }}
                >
                  Añadir opción
                </Button>
              ) : null}
              {props.information.customOptions.length >= 3 ? (
                <Button
                  variant="text"
                  startIcon={<AddCircleOutlineIcon />}
                  onClick={() =>
                    props.handleRemoveOption(
                      props.information.customOptions.length - 1,
                    )
                  }
                  style={{ backgroundColor: '#F7F7F7', width: '255px' }}
                >
                  Eliminar opción
                </Button>
              ) : null}
            </div>
          </LayoutQuestion>
        );
      case 25:
        return <MatrixQuestion {...props} />;

      case 26:
        return <ComplexQuestion {...props} />;
      case 27:
        return <SelectionQuestion {...props} />;
      case 28:
        return <MediaQuestion {...props} />;
      case 29:
        return <TableQuestion {...props} />;
      case 30:
        return <FileUploadQuestion {...props} />;
      default:
        return null;
    }
  };
  return (
    <Fragment>
      <div className={styles.form}>
        {props.type === '' || props.type === null
          ? null
          : renderForm(props.type)}
      </div>
      {!props.isConditionalQuestion && (props.type && props.type.id) !== 21 && (
        <Box
          sx={{
            mt: 2,
          }}
        >
          <FormControl fullWidth error={props.categoryError.length > 0}>
            <InputLabel
              id="category-id-label"
              sx={{
                backgroundColor: 'white',
                paddingRight: '0 6px',
              }}
            >
              Seleccionar categoría
            </InputLabel>
            <Select
              labelId="category-id-label"
              id="category-id"
              label="Categoría"
              value={categoryId}
              onChange={handleCategoryIdChange}
            >
              <MenuItem value={props.categoryId}>
                <em>Seleccione</em>
              </MenuItem>
              {props.categories.map((category) => (
                <MenuItem key={category.id} value={category.id}>
                  {category.nameCatogory}
                </MenuItem>
              ))}
            </Select>
            {props.categoryError.length > 0 && (
              <FormHelperText>{props.categoryError}</FormHelperText>
            )}
          </FormControl>
        </Box>
      )}
    </Fragment>
  );
}
